import type { PaginationProps } from './Pagination';
import type { PaginationArrowProps } from './PaginationArrow';

export type OldPaginationProps = Omit<PaginationProps, 'page' | 'hasArrows' | 'onChange'> & {
  /** @deprecated page를 대신 사용해주세요. */
  currentPage: number;
  /** @deprecated hasArrows를 대신 사용해주세요. */
  showArrowButton?: PaginationProps['hasArrows'];
  /** @deprecated onChange를 대신 사용해주세요. */
  onChangePage?: PaginationProps['onChange'];
};

export function convertOldPaginationProps(props: OldPaginationProps): PaginationProps {
  const { currentPage, showArrowButton, onChangePage, ...restProps } = props;

  return {
    ...restProps,
    page: currentPage,
    hasArrows: showArrowButton,
    onChange: onChangePage,
  };
}

export interface OldPaginationArrowProps extends Omit<PaginationArrowProps, 'direction'> {
  /** @deprecated direction을 대신 사용해주세요. */
  position?: PaginationArrowProps['direction'];
}

export function convertOldPaginationArrowProps(props: OldPaginationArrowProps): PaginationArrowProps {
  const { position, ...restProps } = props;

  return {
    ...restProps,
    direction: position,
  };
}
